module.exports = __webpack_public_path__ + "static/img/logo_pemex_original.0bbb223.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos/logo_pemex_original.png
// module id = 320
// module chunks = 6